export default __webpack_public_path__ + "static/media/cookie_highcontrast--dark.c7f01f69.svg";